module.exports = __webpack_public_path__ + "img/circleInfo.f91518b4.png";